import React, { useState } from "react";
import Icon from "./Icon";
import "./Avatar.scss";

// Fontaine M25 — Avatar. Visual contract: Style Guide V2 `avatar` (40px circle, accent-soft fill, lilac initials).
// Image with initials fallback; store variant is a rounded square with the store's flag or a globe for Master.

export const initialsOf = (name) =>
  String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");

/**
 * @param {string} [name]                 used for initials and the accessible name
 * @param {string} [src]                  image; falls back to initials on error
 * @param {"xs"|"sm"|"md"|"lg"|"xl"} [size="md"]   24 · 28 · 40 · 48 · 64
 * @param {"user"|"store"} [variant="user"]         store = rounded square
 * @param {string} [flag]                 emoji flag for a store (country); Master store passes `master`
 * @param {boolean} [master]              globe instead of a flag
 * @param {"online"|"offline"} [presence]
 */
export default function Avatar({ name, src, size = "md", variant = "user", flag, master = false, presence, className = "", ...rest }) {
  const [broken, setBroken] = useState(false);
  const label = rest["aria-label"] || name || (master ? "Master store" : "Avatar");
  const classes = ["ft-avatar", `ft-avatar--${size}`, `ft-avatar--${variant === "store" ? "store" : "user"}`, className].filter(Boolean).join(" ");
  let body;
  if (src && !broken) body = <img className="ft-avatar__img" src={src} alt="" onError={() => setBroken(true)} />;
  else if (master) body = <span className="ft-avatar__glyph" aria-hidden="true"><Icon name="Globe" size={size === "xs" || size === "sm" ? "xs" : "sm"} /></span>;
  else if (flag) body = <span className="ft-avatar__flag" aria-hidden="true">{flag}</span>;
  else body = <span className="ft-avatar__initials" aria-hidden="true">{initialsOf(name) || "?"}</span>;
  return (
    <span className={classes} role="img" aria-label={label} {...rest}>
      {body}
      {presence ? <span className={`ft-avatar__presence is-${presence}`} aria-hidden="true" /> : null}
    </span>
  );
}
